import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { Loader2, Flame } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useApp();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || window.location.hash;
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { navigate("/", { replace: true }); return; }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const { data } = await http.post("/auth/google/callback", { session_id: sessionId });
                localStorage.setItem("sf_token", data.token);
                // Clear hash then refresh app state, then go to studio
                window.history.replaceState(null, "", window.location.pathname);
                if (refresh) await refresh();
                toast.success("Signed in with Google");
                navigate("/studio", { replace: true });
            } catch (e) {
                toast.error(e?.response?.data?.detail || "Google sign-in failed");
                navigate("/auth?mode=login", { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-screen bg-[#080B10] flex items-center justify-center">
            <div className="text-center">
                <div className="mx-auto w-14 h-14 rounded-lg flame-gradient grid place-items-center flame-glow mb-4">
                    <Flame className="w-6 h-6 text-black" strokeWidth={3} />
                </div>
                <div className="flex items-center gap-2 text-slate-400 font-mono-sf text-xs">
                    <Loader2 className="w-4 h-4 animate-spin text-[#FF4D00]" /> SIGNING YOU IN ···
                </div>
            </div>
        </div>
    );
}
